export interface FabricObject extends fabric.Object {
  id: string;
}

export interface FabricClearEvent extends fabric.IEvent {
  deselected?: FabricObject[] | undefined;
}

export enum FabricEvents {
  objectModified = "object:modified",
  objectMoving = "object:moving",
  objectScaling = "object:scaling",
  objectRotating = "object:rotating",
  objectSkewing = "object:skewing",
  objectResizing = "object:resizing",
  objectAdded = "object:added",
  objectRemoved = "object:removed",
  beforeTransform = "before:transform",
  beforeSelectionCleared = "before:selection:cleared",
  selectionCleared = "selection:cleared",
  selectionCreated = "selection:created",
  selectionUpdated = "selection:updated",
  mouseUp = "mouse:up",
  mouseDown = "mouse:down",
  mouseMove = "mouse:move",
  mouseUpBefore = "mouse:up:before",
  mouseDownBefore = "mouse:down:before",
  mouseMoveBefore = "mouse:move:before",
  mouseDoubleClick = "mouse:dblclick",
  mouseWheel = "mouse:wheel",
  mouseOver = "mouse:over",
  mouseOut = "mouse:out",
  dropBefore = "drop:before",
  drop = "drop",
  dragover = "dragover",
  dragenter = "dragenter",
  dragleave = "dragleave",
  afterRender = "after:render",
}
